<template>
  <section id="assist__videos">
    <div class="top">
      <p>感谢您参与助力活动，赠送 3 集趣蒙视频课：</p>
    </div>
    <div class="switcher">
      <div
        class="switcher__item"
        :class="{ active: active && item.id === active.id }"
        v-for="item in videos"
        :key="item.id"
        @click="active = item"
      >{{ item.title }}</div>
    </div>
    <div class="video" v-if="active">
      <video
        :id="'TCPlayer' + nonce"
        :src="active.url"
        preload="auto"
        playsinline
        webkit-playsinline
      ></video>
    </div>
    <p class="desc" v-if="active && active.content">
      <i class="anyteachicon anyteach-icon-quote" />
      {{ active.content }}
    </p>
  </section>
</template>

<script>
export default {
  name: "AssistVideos",
  props: ["videos"],
  data() {
    return {
      active: null,
      TCPlayer: null,
      nonce: Date.now(),
      appID: "1257393913",
    }
  },
  watch: {
    active(val) {
      if (!this.TCPlayer) {
        this.$nextTick(() => {
          this.TCPlayer = TCPlayer("TCPlayer" + this.nonce, {
            fileID: val.video_id,
            appID: this.appID,
            controlBar: {
              playbackRateMenuButton: false,
              volumePanel: false,
            },
          })
        })
      } else {
        this.$nextTick(() => {
          this.TCPlayer.loadVideoByID({
            fileID: val.video_id,
            appID: this.appID,
          })
          this.TCPlayer.on("canplay", () => {
            this.TCPlayer.play()
          })
        })
      }
    },
  },
  mounted() {
    this.active = this.videos[0]
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__videos {
  padding-left: 5%;
  padding-right: 5%;
  text-align: left;
}

.top {
  padding: 0 0 10px 0;
  p {
    @include secondary();
    @include avenir();
    font-size: 0.9rem;
  }
}

.switcher {
  margin: 0 0 15px 0;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  .switcher__item {
    @include avenir-demi();
    padding: 6px 8px;
    border: 1px solid $purple;
    display: inline-block;
    border-radius: 4px;
    color: $purple;
    font-size: 0.9rem;
    transition: all 0.1s;
    margin: 0 10px 0 0;
  }
  .switcher__item:last-of-type {
    margin: 0;
  }
  .active {
    color: white;
    background: $purple;
  }
}

.video {
  width: 100%;
  border-radius: 4px;
  position: relative;
  max-height: 300px;
  max-width: 550px;

  video {
    border-radius: 4px;
    width: 100%;
    height: auto;
    max-height: 300px;
    max-width: 550px;
    position: relative;
  }
}
.desc {
  font-size: 0.9rem;
  padding: 15px 0 0 0;
  @include avenir();
  line-height: 1.6;
}
</style>

<style lang="scss">
// @import "../../../../static/css/public.scss";

.video-js {
  border-radius: 4px;
  width: 100%;
  max-width: 550px;
  height: auto;
  max-height: 300px;
  box-shadow: 0 0 25px 0 #efefef;
  button {
    &:hover,
    &:active {
      background: none;
    }
  }
}
.vjs-control-bar {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.vjs-current-time-display,
.vjs-duration-display {
  // font-size: 0.9rem;
}

.tcp-quality-switcher-value * {
  color: white;
  font-weight: 500;
  // font-size: 0.9rem;
}

.vjs-poster {
  border-radius: 4px;
}
.vjs-menu-content {
  border-radius: 5px;
  bottom: 10px;
  * {
    font-size: 0.9rem;
    font-weight: 500;
  }
}
</style>
